export default __webpack_public_path__ + "static/media/new_banner.c17ed7fc.png";